import React, { Fragment } from 'react';
import { map } from 'lodash';
import { Checkbox } from 'semantic-ui-react';

import ErrorMessage from './errorMessage';

// raido should have radioGroupName
// item must have fields, label and value
const HHRadioGroup = ({ field, form: { touched, errors, setFieldValue }, otherProps }) => {
  const { items, radioGroupName, ...restOtherProps } = otherProps;
  const hasError = !!(touched[field.name] && errors[field.name]);

  return (
    <Fragment>
      { map(items, (item, index) => (
        <div key={index}>
          <Checkbox
            name={radioGroupName}
            label={item.label}
            value={item.value}
            checked={field.value === item.value}
            onChange={(e, { value }) => {
              setFieldValue(field.name, value);
            }}
            {...restOtherProps}
          />
        </div>
      )) }
      {hasError && (<ErrorMessage error={errors[field.name]} />)}
    </Fragment>
  );
};

export default HHRadioGroup;



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhRadioGroup.js